import { paths } from "api/schema/api-schema";
import assert from "assert";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";

export type ValidateTablesResponse = {
  inputs: {
    id: string;
    key: string;
    name: string;
    required: boolean;
    table_id: string;
    intermediate: boolean;
  }[];
  steps: {
    id: string;
    table_id: string;
    table_name: string;
    table_key: string;
    name: string;
    tool_name: string;
    version: { id: number; version: string };
  }[];
  results: {
    id: string;
    source_table_id: string;
    key: string;
    name: string;
    description: string;
    intermediate: boolean;
  }[];
  edges: { source: string; target: string }[];
};

const path = "/wrs/workflow/validate_tables/" satisfies keyof paths;

export const workflowValidateTables = djangoClientQueryFactory(
  { path, method: "post" },
  {
    formatInput: (
      body: paths[typeof path]["post"]["requestBody"]["content"]["application/json"],
    ) => ({ body }),
    handleResponse: (res) => {
      const data = res.data;
      assert(data !== undefined, "Expected data to be defined in response");
      return data as unknown as ValidateTablesResponse;
    },
  },
);
